import { useUI } from '@components/ui'
import { FC } from 'react'
import ClickAndCollect from './ClickAndCollect'
import Delivery from './Delivery'
import Notice from '@components/common/Notice'
import HowCanIGetIt from '@components/product/FulfilmentWidget/HowCanIGetIt'

interface Props {
  totalInventoryQuantity: number
  shippable?: boolean
}

export const FulfilmentWidget: FC<Props> = ({
  totalInventoryQuantity = 0,
  shippable = true,
}) => {
  const { toggleSidebar, setSidebarView } = useUI()

  const openSidebar = (sidebar: string) => {
    setSidebarView(sidebar)
    toggleSidebar()
  }
  return (
    <div className="flex flex-col">
      <div className="flex flex-col pt-4 mr-1 ">
        {!totalInventoryQuantity && (
          <HowCanIGetIt
            onOpenSidebar={openSidebar}
            data-testid="how-can-i-get-it"
          />
        )}
        <div className="p-4 shadow-fulfilment">
          <Delivery inventory={totalInventoryQuantity} shippable={shippable} />
          <ClickAndCollect inventory={totalInventoryQuantity} />
        </div>
        <div className="mb-4 text-body2 text-text-disabled pt-4">
          *You’ll select your fulfilment method at checkout
        </div>
      </div>
      <div
        className="mt-2 cursor-pointer"
        onClick={() => openSidebar('SERVICE_PORTAL_VIEW')}
      >
        <Notice
          icon="chat"
          title="Seen this product elsewhere?"
          content="Contact us to find out if we can match the price!"
          colour="message-warning"
          data-testid="price-match-module"
        />
      </div>
      <div className="mt-4">
        <Notice
          icon="fulfilmentInfo"
          title="Deliver to Store"
          content='Orders processed during office hours 9am - 4pm EST.
          Wait for your "Ready to Collect" message before heading in store.'
        />
      </div>
    </div>
  )
}

export default FulfilmentWidget
